"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const CoupleGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "COUPLE-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.866 7.666a5.868 5.868 0 0 1 5.867 5.868v2.3a.5.5 0 0 1-.5.5l-1.848-.001-.721 7.219a.5.5 0 0 1-.414.443l-.084.007h-4.6a.5.5 0 0 1-.498-.45l-.723-7.219-1.847.001a.5.5 0 0 1-.492-.41l-.008-.09v-2.3a5.868 5.868 0 0 1 5.868-5.868m0 1a4.868 4.868 0 0 0-4.868 4.868v1.799l1.8.001a.5.5 0 0 1 .483.367l.015.083.721 7.217h3.696l.722-7.217a.5.5 0 0 1 .414-.443l.084-.007 1.8-.001v-1.8a4.868 4.868 0 0 0-4.65-4.862Zm0-8.668a3.567 3.567 0 1 1 0 7.134 3.567 3.567 0 0 1 0-7.134m0 1a2.567 2.567 0 1 0 0 5.134 2.567 2.567 0 0 0 0-5.134ZM19.7 7.883a5.868 5.868 0 0 1 4.297 5.404l.005.247v2.3a.5.5 0 0 1-.41.492l-.09.008-1.848-.001-.722 7.219a.5.5 0 0 1-.413.443l-.084.007h-4.601a.5.5 0 0 1-.482-.368l-.016-.082-.722-7.219-1.08.001a.5.5 0 0 1-.492-.41l-.008-.09a.5.5 0 0 1 .41-.492l.09-.008h1.533a.5.5 0 0 1 .482.367l.016.083.721 7.217h3.696l.722-7.217a.5.5 0 0 1 .414-.443l.083-.007 1.8-.001v-1.799a4.868 4.868 0 0 0-3.352-4.622l-.216-.065a4.868 4.868 0 0 0-5.47 2.184.5.5 0 0 1-.858-.515A5.868 5.868 0 0 1 19.7 7.883M18.134-.002a3.567 3.567 0 1 1 0 7.134 3.567 3.567 0 0 1 0-7.134m0 1a2.567 2.567 0 1 0 0 5.134 2.567 2.567 0 0 0 0-5.134Z"
  })));
};
CoupleGraphicIcon.displayName = "CoupleGraphicIcon";
CoupleGraphicIcon.iconName = "Couple";
export default CoupleGraphicIcon;